__turbopack_context__.v({
  "auctionStart": "dropAuctionTimer-module-scss-module__1hdO1q__auctionStart",
  "auctionTimerHeading": "dropAuctionTimer-module-scss-module__1hdO1q__auctionTimerHeading",
  "center": "dropAuctionTimer-module-scss-module__1hdO1q__center",
  "day": "dropAuctionTimer-module-scss-module__1hdO1q__day",
  "hour": "dropAuctionTimer-module-scss-module__1hdO1q__hour",
  "looseScreen": "dropAuctionTimer-module-scss-module__1hdO1q__looseScreen",
  "min": "dropAuctionTimer-module-scss-module__1hdO1q__min",
  "moss": "dropAuctionTimer-module-scss-module__1hdO1q__moss",
  "peach": "dropAuctionTimer-module-scss-module__1hdO1q__peach",
  "pistachio": "dropAuctionTimer-module-scss-module__1hdO1q__pistachio",
  "sec": "dropAuctionTimer-module-scss-module__1hdO1q__sec",
});
